export const MODAL_CONTENT = [
  {
    title: 'Рады видеть вас на Циан!',
    description: '1 000 бонусов уже зачислены. Опубликуйте ваше первое объявление уже сегодня.',
    imageClass: 'applied',
    btnText: 'Опубликовать',
  },
  {
    title: 'Спасибо, что вы с нами!',
    description:
      'Ранее вы уже размещались на Циан через один из ваших аккаунтов. Бонус на продвижение только для новых пользователей',
    imageClass: 'canceled',
    btnText: 'В личный кабинет',
  },
  {
    title: 'Что-то пошло не так, обновите страницу',
    imageClass: 'error',
    btnText: 'Обновить',
  },
  {
    title: 'Спасибо, что вы с нами!',
    description:
      'Мы уже начислили приветственные 1 000 бонусов, проверьте личный кабинет и разместите свое первое объявление на Циан уже сегодня!',
    imageClass: 'applied',
    btnText: 'В личный кабинет',
  },
];
